document.addEventListener("DOMContentLoaded", function () {
  const filters = document.querySelectorAll(".post-filters button");
  const wrapper = document.getElementById("posts-wrapper");

  function updatePosts(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    wrapper.innerHTML = doc.getElementById("posts-wrapper").innerHTML;
    attachPagination();
  }

  function fetchBlog(handle) {
    const url = handle === "all"
      ? `/blogs/news?view=ajax`       // “all” defaults to News
      : `/blogs/${handle}?view=ajax`;
    fetch(url)
      .then(r => r.text())
      .then(updatePosts)
      .catch(console.error);
  }

  filters.forEach(btn => {
    btn.addEventListener("click", () => {
      fetchBlog(btn.dataset.blog);
    });
  });

  function attachPagination() {
    document.querySelectorAll(".page-link").forEach(link => {
      link.addEventListener("click", e => {
        e.preventDefault();
        let href = link.getAttribute("href");
        // ensure view=ajax param
        href += href.includes("?") ? "&view=ajax" : "?view=ajax";
        fetch(href)
          .then(r => r.text())
          .then(updatePosts)
          .catch(console.error);
      });
    });
  }

  attachPagination();
});
